export class Building {
     id: number;
     price: number;
     price_type: string;
     name: string;
     add_date: number;
     arch_style_id: number;
     building_type_id: number;
     basement_id: number;
     total_rooms: number;
     year_of_build: number;
     structural_remodel_year: string;
     description: string;
     edit_date: string;
     address: string;
     cool_type_id: number;
     owner_price: number;
     active: number;
     size: number;
     size_type_id: number;
     phone: string;
     action_type_id: number;
     build_type_group_id: number;
     owner: string;
     imagePath: string;
     region:string;
     lot_size:number;

    constructor(
        // id: number,
        // name: string,
        // price: number,
        // price_type: string,
        // add_date: number,
        // arch_style_id: number,
        // building_type_id: number,
        // basement_id: number,
        // total_rooms: number,
        // year_of_build: number,
        // structural_remodel_year: Date,
        // description: string,
        // edit_date: Date,
        // address: string,
        // cool_type_id: number,
        // owner_price: number,
        // active: number,
        // size: number,
        // size_type_id: number,
        // phone: number,
        // action_type_id: number,
        // build_type_group_id: number,
        // owner: string,
        // imagePath: string
        ) {

        // this.id = id;

        // this.name = name;

        // this.description = description;

        // this.imagePath = imagePath;

        // this.price = price;

        // this.price_type = price_type;
        
        // this.add_date=add_date;
        
        // this.arch_style_id=arch_style_id;

        // this.building_type_id=building_type_id;
        
        // this.basement_id=basement_id;
        
        // this.total_rooms=total_rooms;
        
        // this.year_of_build=year_of_build;
        
        // this.structural_remodel_year=structural_remodel_year;
        
        // this.edit_date=edit_date;
    
        // this.address=address;
        
        // this.cool_type_id=cool_type_id;

        // this.owner_price=owner_price;
        
        // this.active=active;
     
        // this.size=size;

        // this.size_type_id=size_type_id,
       
        // this.phone=phone,

        // this.owner=owner;

        // this.action_type_id = action_type_id;

        // this.build_type_group_id= build_type_group_id;


    }

}